export const aneks_ugovora_o_radu_1 = {
  templateId: 5.1,
  category: 11,
  templateTitle: "Aneks ugovora o radu",
  templateDescription: `</p>Aneksom se suglasnošću volja obje ugovorne strane, u pisanom obliku mijenjanju odredbe ugovora o radu.</p>`,
  description: `
    <h5>OPIS DOKUMENTA</h5>
    <p>Ugovor o radu  je dvostrano obvezni ugovor koji se može mijenjati suglasnošću volja obje ugovorne strane u pisanom obliku (ugovor o radu mora biti također u pisanom obliku).</p>
    <p><strong>Ovdje je svakako bitno naglasiti da se svaka izmjena ugovora o radu na određeno vrijeme, odnosno dopuna ugovora o radu na određeno vrijeme, točnije svaki aneks/dodatak ugovoru o radu na određeno vrijeme koji bi utjecao na produljenje ugovorenog trajanja toga ugovora, smatra  uzastopnim ugovorom o radu na određeno vrijeme (novim ugovorom o radu na određeno vrijeme).</strong></p>
    <p>U tom smislu, svejedno je da li se ugovor produljuje aneksom ugovora o radu na određeno vrijeme ili novim ugovorom o radu na određeno vrijeme.</p> 
    <p>Ovim primjerom aneksa ugovora o radu navodi se način na koji se određeni članci ugovora o radu mijenjaju odnosno dodaju, a isti način se može primijeniti i na stavke (sadržaj) pojedinog članka.</p>
    <h5>SVRHA DOKUMENTA</h5>
    <p>Ugovorne strane aneksom/dodatkom ugovora dopunjuju ili mijenjaju svoja međusobna prava i obveze.</p>
    <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong>- Nenavođenje koji članak/stavak ugovora o radu se mijenja, a koji se dodaje</strong></p>
    <p>Pojašnjenje: nenavođenjem takvih podataka otežava se tumačenje i valjana primjena ugovora o radu.</p>
    <h5>PRAVNA OSNOVA</h5>
    <p> Zakon o radu, Pravilnik o radu.</p>
  `,

  sides: [
    {
      prefix: "Na temelju odredaba Zakona o radu i Pravilnika o radu,",
      signature: "Za Poslodavca:",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }],
      suffix: " (u daljnjem tekstu: Poslodavac)",
      delimiter: `i`
    },
    {
      signature: "Radnik:",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Ime i prezime",
        label: "Ime i prezime",
        inSignature: true,
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      ],
      suffix: " (u daljnjem tekstu: Radnik),"
    }
  ],

  headline: "zaključuju sljedeći",
  title: "ANEKS UGOVORA O RADU",

  articles: [
    {
      title: '',
      mandatory: false,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: false,
          choices: [
            {
              parts: [
                { type: "text", content: "Ugovorne strane su dana " },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine zaključile Ugovor o radu na neodređeno vrijeme (u daljnjem tekstu: Ugovor o radu)." },
              ]
            },
            {
              parts: [
                { type: "text", content: "Ugovorne strane su dana " },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine zaključile Ugovor o radu na određeno vrijeme (u daljnjem tekstu: Ugovor o radu)." },
              ]
            }],
          value: "",
        }
      ]
    },
    {
      title: '',
      mandatory: false,
      exampleContent: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content:
            `Ovim Aneksom ugovorne strane Ugovoru o radu dodaju novi članak 9. a) koji glasi:\r\n"Radnik se potpisom ovog Ugovora obvezuje Poslodavcu vratiti ukupne troškove edukacije nastale u razdoblju od dvije godine prije dana prestanka radnog odnosa i to u roku od 15 dana od dana prestanka radnog odnosa. Ukoliko u navedenom roku Radnik ne podmiri sva dospjela dugovanja, početi će se obračunavati zakonska zatezna kamata.\r\nTroškovi edukacije iz stavka 1. ovog članka koje je Radnik dužan vratiti, utvrđuju se prema evidenciji realizirane edukacije Radnika i prema stvarnoj cijeni ostvarene edukacije uključujući popratne realizirane troškove Poslodavca vezane uz edukaciju (trošak prijevoza, smještaja i sl.).\r\nU slučaju specifičnog stručnog usavršavanja Radnika, prava i obveze ugovornih strana urediti će se posebnim ugovorom."`,
        },
      ]
    },
    {
      title: '',
      mandatory: false,
      statements: [
        {
          type: "input",
          mandatory: true,
          editable: false,
          parts: [
            { type: "text", content: "Odredbe ovog aneksa primjenjuju se od dana potpisa, odnosno od" },
            { type: "input", value: "", required: true, },
            { type: "text", content: "godine." }
          ]
        },
      ]
    },
    {
      title: '',
      mandatory: false,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: `Sve ostale odredbe Ugovora o radu ostaju iste i neizmijenjene.`,
        }]
    },
    {
      title: '',
      mandatory: false,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: `Ugovorne strane, u znak prihvata, potpisuju ovaj Aneks Ugovoru o radu.`,
        }]
    },
    {
      title: '',
      mandatory: false,
      statements: [
          {
              type: 'text',
              required: false,
              mandatory: true,
              editable: true,
              content: 'Ovaj Aneks sastavljen je u 2 (dva) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
              value: '',
          }],
    },
    {
      mandatory: true,
      static: true,
      type: 2, // date and place
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            {
              type: "text",
              content: "U"
            },
            {
              type: "input",
              value: "",
              placeholder: "Upišite mjesto.",
              required: true,
            },
            {
              type: "text",
              content: ", dana"
            },
            {
              type: "date",
              value: new Date(),
              required: true
            },
            {
              type: "text",
              content: "godine."
            }
          ]
        },
      ]
    },
    {
      mandatory: true,
      static: true,
      type: 3,  // signatures
      statements: [],
    }
  ],
};


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/5.1_aneks_ugovora_o_radu.1.ts